var _linearGradient, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "iconify iconify--noto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 55.273,
    y1: 43.106,
    x2: 55.273,
    y2: 106.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#1483bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#1f8cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#3ca4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#62c2e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#99d6ef"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m102.92 75.96-4.08-6.12L82.1 49.39s-15.07-6.58-25.28-6.23c-7.04.24-20.67-2.22-35.63 10.1-11.21 9.23-13.56 19.9-13.56 19.9l11.09 6.16-8.45 5.63s9.72 17.82 36.62 21.3c31.89 4.13 43.57-12.49 50.68-21.78.74-.97 5.35-8.51 5.35-8.51",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.66 27.63c-.84.47-6.55 5.19-9.22 8.56-2.36 2.98-4.86 7.32-4.86 7.32s12.67-.4 21.87 2.7 19.58 9.88 27.59 19.33c6.15 7.25 7.77 10.14 7.84 11.47.07 1.34-5.07 7.81-10.65 13.4-3.57 3.57-7.09 6.95-16.38 12.29-4.37 2.51-7.81 3.38-7.81 3.38s10.16 1.77 15.13 1.83c5.54.07 8.78-.33 9.15-1.64.38-1.31-5.82-6.01-5.82-6.01s6.62-5.35 11.31-10.86c1.86-2.19 6.71-8.38 6.71-8.38s5.18 5.39 8.14 7.88c3.1 2.6 10.42 8.17 11.57 7.7 1.32-.54-1.5-8.92-3.38-12.29-1.88-3.38-6.76-7.98-6.76-7.98s6.17-4.74 8.42-10.09 3.97-12.34 2.56-13-10.68 8.87-12.55 10.75c-1.88 1.88-7.02 8.09-7.02 8.09s-4.36-4.58-5.39-5.8-4.32-5.35-4.32-5.35-7.03-14.3-19.62-24.31c-8.72-6.93-16.51-8.99-16.51-8.99",
    fill: "#1b65a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.93 77.79c0 1.69-.77 7.34 4.22 11.05 5.81 4.31 14.55 5.04 17.83 4.86 5.04-.28 7.23-1.6 7.23-1.6s-5.16-6.48-14.27-10.89-15.01-3.42-15.01-3.42m-43.64-5c-.86 1.66.28 2.42 3.1 3.73s7.13 2.91 7.13 2.91-2.72 1.13-4.13 2.06c-1.41.94-3.95 1.89-3.28 3.57.49 1.24 1.69 1.13 3.94-.09s7.23-4.32 7.32-5.54-3.21-3.24-5.77-4.6c-3.1-1.64-7.33-3.94-8.31-2.04",
    fill: "#1b65a6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6 69.01c0 1.94-1.23 3.59-3.66 3.75-2.82.19-3.94-1.86-3.94-3.8s1.83-3.47 3.61-3.64c2.33-.2 3.99 1.75 3.99 3.69",
    fill: "#262d33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3 70.89c-.95.13-1.31 1.31-1.22 3.19s.56 3.38.28 4.41-4.22 6.48-4.97 7.51-1.69 2.53-.66 3.38 2.35-.28 3.1-1.03 5.82-7.41 6.01-8.92c.19-1.5-.47-5.16-.56-5.91-.1-.75-.57-2.82-1.98-2.63m4.88 0c-.09 1.6 1.78 1.69 3.94 1.69 1.97 0 13.38.52 19.57.84 6.62.35 15.58 1.95 19.54 2.63 2.35.4 4.6.94 4.6-.66 0-1.52-2.46-1.76-4.88-2.25-2.04-.42-8.56-2.18-19.19-2.84-7.97-.49-18.7-.82-19.92-.73-1.22.1-3.57-.2-3.66 1.32",
    fill: "#e0ecf3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.93fce01d97ca5f3c8e6ea5fe456a4870.svg";
export { ForwardRef as ReactComponent };